import { createFileRoute } from '@tanstack/react-router'
import { ContactEditor } from '../-ContactEditor'

export const Route = createFileRoute('/crm/contacts/$id/')({
  component: ContactDetailPage,
})

function ContactDetailPage() {
  const { id } = Route.useParams()
  return <ContactEditor id={id} />
}
